import { render } from "./NotFound.vue?vue&type=template&id=aa29f21a"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__